<template>
  <ViewCustomRow @refreshRow="refreshRow" @addNewRow="addNewRow" @hide="onHideDialog" v-model:showRowDialog="showDialog"
    :rowId="rowId" :masterDetail="masterDetail" :dialogOptions="dialogOptions" :permissions="permissions"
    :entityKey="entityKey" entityName="property" entitySpec="facility" ref="FacilityPropertyDialog"
    :requiredFields="FACILITY_PROPERTY_REQUIRED_FILEDS" :style="{ width: '80%' }">
    <template #header="{ rowData }">
      {{ rowId === -1 ? 'Новое свойство' : 'Свойство (' + rowData.property_name + ')' }}
    </template>
    <template #body="{ rowData, submitted }">
      <div class="formgrid grid align-items-center vertical-container">
        <div class="col-6">
          <div class="formgrid grid align-items-center vertical-container mt-2">
            <div class="col-2">
              <label for="property_id">PID:</label>
            </div>
            <div class="col-4">
              <InputText id="property_id" disabled v-model="rowData.property_id" />
            </div>
            <div class="col-2">
              <label for="active_flange_no">Фланец:</label>
            </div>
            <div class="col-4">
              <InputNumber id="active_flange_no" v-model="rowData.active_flange_no" mode="decimal" showButtons :min="0"
                :max="30" :class="{
                  'p-required': isRequired('active_flange_no'),
                  'p-invalid': isInvalid(submitted, rowData.active_flange_no)
                }" />
            </div>
          </div>

          <div class="formgrid grid align-items-center vertical-container mt-2">
            <div class="col-2">
              <label for="property_name">Тип свойств:</label>
            </div>
            <div class="col-4">
              <Dropdown id="property_name" v-model="rowData.property_type_id" filter
                :options="dialogOptions['propertyType'] ? dialogOptions['propertyType'] : []"
                optionLabel="property_type_name" optionValue="property_type_id" appendTo="body" :class="{
                  'p-required': isRequired('property_type_id'),
                  'p-invalid': isInvalid(submitted, rowData.property_type_id)
                }" />
            </div>
            <div class="col-2">
              <label for="property_sysname">Системное имя:</label>
            </div>
            <div class="col-4">
              <Dropdown id="property_sysname" v-model="rowData.property_type_id"
                :options="dialogOptions['propertyType'] ? dialogOptions['propertyType'] : []"
                optionLabel="property_type_sysname" optionValue="property_type_id" appendTo="body" disabled :class="{
                  'p-required': isRequired('property_type_id'),
                  'p-invalid': isInvalid(submitted, rowData.property_type_id)
                }" />
            </div>
          </div>

          <div class="formgrid grid align-items-center vertical-container mt-2">
            <div class="col-2">
              <label for="device_id">Устройство:</label>
            </div>
            <div class="col-4">
              <Dropdown id="device_id" v-model="rowData.device_id"
                :options="dialogOptions['device'] ? dialogOptions['device'] : []" optionLabel="device_name"
                optionValue="device_id" appendTo="body" :class="{
                  'p-required': isRequired('device_id'),
                  'p-invalid': isInvalid(submitted, rowData.device_id)
                }" />
            </div>
            <div class="col-2">
              <label for="source_name">Источник:</label>
            </div>
            <div class="col-4">
              <InputText id="source_name" disabled v-model="rowData.source_name" />
            </div>
          </div>

          <div class="formgrid grid align-items-center vertical-container mt-2">
            <div class="col-2">
              <label for="property_path">Ручной Path:</label>
            </div>
            <div class="col-4">
              <InputText id="property_path_text" v-model="rowData.property_path" :class="{
                'p-required': isRequired('property_path'),
                'p-invalid': isInvalid(submitted, rowData.property_path)
              }" />
            </div>
            <div class="col-2">
              <label for="property_path">Список Path:</label>
            </div>
            <div class="col-4">
              <Dropdown id="property_path" v-model="rowData.property_path" filter :options="dialogOptions['source'] && dialogOptions['source'].length
                ? dialogOptions['source']
                : dialogOptions['allSource']
                " optionLabel="source" optionValue="property_path" appendTo="body" :class="{
                  'p-required': isRequired('property_path'),
                  'p-invalid': isInvalid(submitted, rowData.property_path)
                }" />
            </div>
          </div>

          <div class="formgrid grid align-items-center vertical-container mt-2">
            <div class="col-2">
              <label for="unit_name">Единица измерения (входная):</label>
            </div>
            <div class="col-4">
              <Dropdown id="unit_name" v-model="rowData.unit_id"
                :options="dialogOptions['unit'] ? dialogOptions['unit'] : []" optionLabel="unit_name"
                optionValue="unit_id" appendTo="body" :class="{
                  'p-required': isRequired('unit_id')
                }" />
            </div>

            <div class="col-2">
              <label for="property_factor">Коэффициент:</label>
            </div>
            <div class="col-4">
              <InputNumber id="property_factor" v-model="rowData.property_factor" mode="decimal" :minFractionDigits="5"
                :step="0.01" showButtons :class="{
                  'p-required': isRequired('property_factor'),
                  'p-invalid': isInvalid(submitted, rowData.property_factor)
                }" />
            </div>
          </div>

          <div class="formgrid grid align-items-center vertical-container mt-2">
            <div class="col-2">
              <label for="property_refresh_rate">Время опроса, сек:</label>
            </div>
            <div class="col-4">
              <InputNumber id="property_refresh_rate" v-model="rowData.property_refresh_rate" mode="decimal" showButtons
                :class="{
                  'p-required': isRequired('property_refresh_rate'),
                  'p-invalid': isInvalid(submitted, rowData.property_refresh_rate)
                }" />
            </div>
            <div class="col-2">
              <label for="property_process_rate">Время обработки, сек:</label>
            </div>
            <div class="col-4">
              <InputNumber id="property_process_rate" v-model="rowData.property_process_rate" mode="decimal" showButtons
                :class="{
                  'p-required': isRequired('property_process_rate'),
                  'p-invalid': isInvalid(submitted, rowData.property_process_rate)
                }" />
            </div>
          </div>

          <div class="formgrid grid align-items-center vertical-container mt-2">
            <div class="col-2">
              <label for="property_save_rate">Время сохранения, сек:</label>
            </div>
            <div class="col-4">
              <InputNumber id="property_save_rate" v-model="rowData.property_save_rate" mode="decimal" showButtons
                :class="{
                  'p-required': isRequired('property_save_rate'),
                  'p-invalid': isInvalid(submitted, rowData.property_save_rate)
                }" />
            </div>
            <div class="col-2">
              <label for="property_is_fast">Непрерывный:</label>
            </div>
            <div class="col-4">
              <Checkbox v-model="rowData.property_is_fast" binary disabled />
            </div>
          </div>

          <div class="formgrid grid align-items-center vertical-container mt-2">
            <div class="col-2">
              <label for="property_is_visible_form">Отобразить в формах:</label>
            </div>
            <div class="col-4">
              <Checkbox v-model="rowData.property_is_visible_form" binary />
            </div>
            <div class="col-2">
              <label for="property_use_source_date">Использовать дату с контроллера:</label>
            </div>
            <div class="col-4">
              <Checkbox v-model="rowData.property_use_source_date" binary />
            </div>
          </div>
        </div>
        <div class="col-6">
          <label for="property_formula">Формула:</label>
          <Highlighter id="property_formula" v-model="rowData.property_formula" langName="js"
            style="resize: none; min-height: 280px; max-height: 280px;" />

          <FloatLabel class="mt-4">
            <InputText id="property_desc" v-model="rowData.property_desc" />
            <label for="property_desc">Описание:</label>
          </FloatLabel>
        </div>
      </div>
    </template>
  </ViewCustomRow>
</template>

<script>
import { ViewCustomRow } from 'cdisoft-library';
import Highlighter from '../scada/components/Highlighter.vue';
import { FACILITY_PROPERTY_REQUIRED_FILEDS } from './facilityConstants';

export default {
  name: 'FacilityPropertyDialog',
  mixins: [ViewCustomRow],
  components: { Highlighter },
  setup() {
    function beforeOpenNewRow(rowData) {
      rowData.facility_id = this.masterDetail.facility_id;
      rowData.property_id = null;
      rowData.active_flange_no = 0;
      rowData.device_id = this.dialogOptions['device']?.length
        ? this.dialogOptions['device'][0].device_id
        : null;
      rowData.property_factor = 1;
      rowData.property_refresh_rate = 10;
      rowData.property_process_rate = 60;
      rowData.property_save_rate = 7200;
      rowData.property_is_visible_form = false;
      rowData.property_use_source_date = false;
    }

    function prepareUpdate(rowData) {
      const data = {
        property_id: rowData.property_id,
        device_id: rowData.device_id,
        facility_id: rowData.facility_id,
        active_flange_no: rowData.active_flange_no,
        property_type_id: rowData.property_type_id,
        unit_id: rowData.unit_id,
        property_path: rowData.property_path,
        property_formula: rowData.property_formula,
        property_factor: rowData.property_factor,
        property_refresh_rate: rowData.property_refresh_rate,
        property_process_rate: rowData.property_process_rate,
        property_save_rate: rowData.property_save_rate,
        property_desc: rowData.property_desc,
        property_is_visible_form: rowData.property_is_visible_form,
        property_use_source_date: rowData.property_use_source_date,
      };

      this.addUniqueSource(rowData);
      return data;
    }

    function prepareInsert(rowData) {
      delete rowData.property_is_fast;
      delete rowData.source_name;
      delete rowData.property_id;
      this.addUniqueSource(rowData);
      return rowData;
    }

    function addUniqueSource(rowData) {
      const newSource = this.addSourceFromData(rowData);
      const exists = this.dialogOptions.allSource?.some(
        (item) => item.property_path === newSource.property_path
      );

      if (!exists) {
        if (!this.dialogOptions.allSource) {
          this.dialogOptions.allSource = [];
        }
        this.dialogOptions.allSource.push(newSource);
      }
    }

    const addSourceFromData = (row) => {
      return { source: row.property_path, property_path: row.property_path };
    };

    const isInvalid = (submitted, value) => {
      return submitted ? (value ?? '') === '' : false;
    };

    const isRequired = (field) => {
      return FACILITY_PROPERTY_REQUIRED_FILEDS[field];
    };

    return {
      FACILITY_PROPERTY_REQUIRED_FILEDS,
      beforeOpenNewRow,
      prepareUpdate,
      prepareInsert,
      isInvalid,
      isRequired,
      addUniqueSource,
      addSourceFromData,
    };
  },
};
</script>